/** MXCreditCardMSIReward card-msi 入口页类型 */
export type MsiRewardPageType = 'cardMsi';

export const MSI_REWARD_PAGE_TYPE = {
    CARD_MSI: 'cardMsi'
} as const satisfies Record<string, MsiRewardPageType>;

/** 埋点 pub_page */
export const MSI_REWARD_PUB_PAGE: Record<MsiRewardPageType, string> = {
    cardMsi: 'card-msi'
};

/** 无 group_type 时的默认 ui_type */
export const MSI_REWARD_DEFAULT_UI_TYPE: Record<MsiRewardPageType, string> = {
    cardMsi: 'C'
};
